import { AxiosInstance } from 'axios';
import { CodeEvent, CodeEventFilters } from 'domain/codeEvent/CodeEvent';
import { ICodeEventRepository } from 'domain/codeEvent/CodeEvent.repository';
import { CodeEventValidity } from 'domain/codeEvent/CodeEventValidity';
import { Pageable } from 'domain/pageable/Pageable';
import { CreateCodeEventsForm } from 'primary/codeEvent/form/CreateCodeEventForm';
import { AxiosProviderRepository } from 'secondary/AxiosProviderRepository';
import { toCodeEvent } from 'secondary/codeEvent/RestCodeEvent';
import { toCodeEventValidity } from 'secondary/codeEvent/RestCodeEventValidity';
import { toPageable } from 'secondary/RestPageable';

export class CodeEventRepository
  extends AxiosProviderRepository
  implements ICodeEventRepository
{
  constructor(readonly axios: AxiosInstance) {
    super(axios);
  }

  create(CreateCodeEventsForm: CreateCodeEventsForm): Promise<CodeEvent> {
    return this.axios
      .post('/unpy/api/code/event', {
        ...CreateCodeEventsForm,
      })
      .then((response) => toCodeEvent(response.data));
  }

  checkValidity(code: string, eventId: number): Promise<CodeEventValidity> {
    return this.axios
      .post('/unpy/api/code/event/validity', {
        code: code,
        eventId: eventId,
      })
      .then((response) => toCodeEventValidity(response.data));
  }

  delete(codeEventIdToDelete: number): Promise<void> {
    return this.axios.delete(`/unpy/api/code/event/${codeEventIdToDelete}`);
  }

  edit(CodeEventEditFormData: CreateCodeEventsForm): Promise<CodeEvent> {
    return this.axios
      .put('/unpy/api/code/event', {
        ...CodeEventEditFormData,
      })
      .then((response) => toCodeEvent(response.data));
  }

  search(
    filters: CodeEventFilters,
    page: number,
    nbPerPage: number,
  ): Promise<Pageable<CodeEvent>> {
    return this.axios
      .get('/unpy/api/code/event', {
        params: {
          ...filters,
          page,
          nbPerPage,
        },
      })
      .then((response) => {
        return toPageable(response, toCodeEvent);
      });
  }
}
